import {
  WSButton,
  WSCard,
  WSElement,
  WSFlexBox,
  WSList,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { IWorkItem } from "@wingspanhq/payments/dist/interfaces";
import { IWorkDefinitionResponse } from "@wingspanhq/payments/dist/interfaces/api/workDefinition";
import { useMemo } from "react";

import { AcceptedValuesResources } from "../FormPartialAttributes/helpers";
import styles from "./index.module.scss";
import { Item } from "./Item";
import { useModalAddItem } from "./ModalAddItem";

type Props = {
  shimmer?: boolean;
  noEdit?: boolean;

  workLogId: string;
  payerId: string;
  payerPayeeEngagementId: string;

  workItems: IWorkItem[];
  workDefinitions: IWorkDefinitionResponse[];
  resources: AcceptedValuesResources;
};

export const CardWorkItems: React.FC<Props> = props => {
  const modalAddItem = useModalAddItem();

  const grossAmount = useMemo(() => {
    return props.workItems.reduce((acc, workItem) => {
      return acc + (workItem.calculations?.result || 0);
    }, 0);
  }, [props.workItems]);

  return (
    <WSElement>
      <WSList gap="M">
        <WSElement>
          <WSSectionToolbar title="Work summary" />
          <WSText.ParagraphSm color="gray500">
            Invoicing for this engagement is only available in U.S. Dollars
            (USD).
          </WSText.ParagraphSm>
        </WSElement>

        <WSCard
          className={props.shimmer ? undefined : styles.itemsCard}
          shimmer={props.shimmer}
        >
          {props.workItems.map(workItem => (
            <Item
              key={workItem.workItemId}
              noEdit={props.noEdit}
              workItem={workItem}
              workDefinitions={props.workDefinitions}
              resources={props.resources}
            />
          ))}

          {!props.noEdit && (
            <WSElement>
              <WSButton.Link
                icon="plus-circle"
                onClick={() => {
                  modalAddItem.open({
                    workLogId: props.workLogId,
                    payerId: props.payerId,
                    workDefinitions: props.workDefinitions,
                    engagementId: props.payerPayeeEngagementId,
                    resources: props.resources
                  });
                }}
              >
                Add work
              </WSButton.Link>
            </WSElement>
          )}
        </WSCard>
        <WSCard shimmer={props.shimmer}>
          <WSFlexBox wrap="nowrap" justify="space-between" alignItems="center">
            <WSText color="gray500" weight="medium">
              Gross amount (USD)
            </WSText>
            <WSText.Heading5>{formatMoney(grossAmount, "USD")}</WSText.Heading5>
          </WSFlexBox>
        </WSCard>
      </WSList>
    </WSElement>
  );
};
